import AxiosBase from 'axios';

const Axios = AxiosBase.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-WP-Nonce': klark.nonce || '',
    },
});

export default Axios;
